export default __webpack_public_path__ + "static/media/diamond.04541695.svg";